import { createBrowserRouter } from "react-router-dom";

import AppLayout from "./layout/AppLayout";
import AcademicsLayout from "./layout/academicsLayout/AcademicsLayout";
import ErrorPageLayout from "./layout/errorPageLayout/ErrorPageLayout";

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <ErrorPageLayout />,
  },
  // {
  //   path: "/academics",
  //   element: <AcademicsLayout />,
  // },
]);

export default appRouter;
